export default __webpack_public_path__ + "static/media/1634234660184*Conseil_de_Vie_Collégienne.64b061ea.pdf";